export default __webpack_public_path__ + "static/media/weightloss@2x.b2efdeac.jpg";